/* eslint-disable indent */
export const TRANSLATION_EN = {
	i18n: {
		language: 'Language',
		languageName: 'English',
		numberFormat: 'en-CH',
	},
	faq: {
		instruction: 'Usage Instructions',
	},
	visualizerComponent: {
		measurementArrowsLabelFormat: 'ET {}',
	},
	highlightComponent: {
		next: 'Next',
	},
	baseFormPlaceholders: {
		userEmailPlaceholder: 'Email',
		userPasswordPlaceholder: 'Password',
		repeatPasswordPlaceholder: 'Repeat Password',
		newPasswordPlaceholder: 'New password',
		repeatNewPasswordPlaceholder: 'Repeat new password',
		userGenderPlaceholder: 'Gender',
		userCompanyPlaceholder: 'Company',
		userCompanyVATNumberPlaceholder: 'Swiss VAT Number',
		userNamePlaceholder: 'Name',
		userFirstNamePlaceholder: 'First name',
		userLastNamePlaceholder: 'Last Name',
		userFunctionPlaceholder: 'Function',
		userCompanyEmailPlaceholder: 'Email',
		userStreetPlaceholder: 'street + nr',
		userZIPPlaceholder: 'zip',
		userCityPlaceholder: 'city',
		userPhonePlaceholder: 'Phone',
		searchField: 'Search',
		userGenderMale: 'Male',
		userGenderFemale: 'Female',
		userGenderDiv: 'Div',
		userFunctionOwner: 'Owner',
		userFunctionCoOwner: 'Co-owner',
		userFunctionManagement: 'Management',
		userFunctionExecutiveManagement: 'Executive Management',
		userFunctionPurchasingProcurement: 'Purchasing / Procurement',
		userFunctionSales: 'Sales',
		userFunctionProjectManagement: 'Project Management',
		userFunctionCalculationCosting: 'Calculation / Costing',
		userFunctionAdministrativeProcessing: 'Administrative Processing',
		userFunctionOther: 'Other',
	},
	commonAppValues: {
		types: '# types',
		created: 'Created',
		lastEdited: 'last edited',
		configuration: 'Configuration',
		notes: 'Notes',
		notesPlaceholder: 'Notes or comments to the CDR team',
		company: 'Company',
		user: 'User',
		orders: 'Orders',
		openOrders: 'Open orders',
		openRequests: 'Open requests',
		drafts: 'Drafts',
		requests: 'Requests',
		completeSomeFmt: 'Complete Selected ({})',
		completeAll: 'Complete All',
		deleteSomeFmt: 'Delete Selected ({})',
		deleteAll: 'Delete All',
		deleteDrafts: 'Delete Drafts',
		deleteOrders: 'Delete Orders',
		deleteRequests: 'Delete Requests',
		confirmCompleteAllOrders: 'Do you want to complete all orders?',
		confirmCompleteAllRequests: 'Do you want to complete all requests?',
		confirmCompleteSomeOrdersFmt: 'Do you want to complete the selected {} orders?',
		confirmCompleteSomeRequestsFmt: 'Do you want to complete the selected {} requests?',
		confirmDeleteAdminNote: 'The customer will keep seeing them until he also deletes them.',
		confirmDeleteAllDrafts: 'Do you want to delete all drafts?',
		confirmDeleteAllOrders: 'Do you want to delete all orders?',
		confirmDeleteAllRequests: 'Do you want to delete all requests?',
		confirmDeleteSomeDraftsFmt: 'Do you want to delete the selected {} drafts?',
		confirmDeleteSomeOrdersFmt: 'Do you want to delete the selected {} orders?',
		confirmDeleteSomeRequestsFmt: 'Do you want to delete the selected {} requests?',
		addPosition: 'Add position',
		companies: 'companies',
		configurationCodeLabel: 'code',
	},
	notifications: {
		errorLoadingConfigurationData: 'Error loading configuration data',
		loadConfiguration: 'Configuration loading...',
		configurationUpdatedSuccessfully: 'Configuration saved.',
		configurationIsSavedInTheCompany: 'The configuration has been saved to your company!',
		configurationUpdatedError: 'An error occurred, configuration not updated',
		configurationNotFound: 'Configuration not found!',
		confirmationOfPositionDeletion: 'Are you sure you want to delete this position?',
		confirmationOfGlassDeletion: 'Are you sure you want to delete this glass configuration?',
		confirmationOfGlassEdit: 'Do you want to edit this glass configuration?',
		errorAddingFileWrongFormat: 'You can only add images and PDFs',
		confirmationOfDocumentDeletion: 'Are you sure you want to delete this document?',
		confirmationOfConfigurationDeletion: 'Are you sure you want to delete this configuration?',
		errorLargeFileSizeFmt: 'Max file size {}',
		accountCreationInProgress: 'Account creation in progress',
		accountCreatedSuccessfully: 'You have signed up successfully',
		orderSuccessful: 'Your order has been submitted. Thank you.',
		quoteSuccessful: 'Your request has been submitted. Thank you.',
		emailSendingInProgress: 'Please wait, message is being sent.',
		configurationDeletionInProgress: 'Configuration deletion in progress',
		configurationWasDeletedSuccessfully: 'Configuration was deleted successfully',
		passwordResetInProgress: 'Password reset in progress',
		passwordHasBeenSuccessfullyChanged: 'Password has been successfully changed',
		pleaseWait: 'Please wait...',
		companyDataWasUpdated: 'Company data was updated!',
		emailWithInstuctionsToResetPasswordHasBeenSent:
			'An email with instructions to reset your password has been sent to you.',
		confirmationOfChangeTypeConfiguration:
			'Are you sure you want to change type of this configuration?',
		configurationTypeChangeInProgress: 'Configuration type change in progress',
		configTypeChangedSuccessfully: 'Configuration type changed successfully!',
		configurationStatusChangeInProgress: 'Configuration status change in progress',
		configurationStatusChangedSuccessfully: 'Configuration status changed successfully!',
		duplicatingConfigWithAllFilesInProgress:
			'Please wait. Duplicating a config with all its files in progress',
		configurationDuplicationCompletedSuccessfully:
			'Configuration duplication completed successfully',
		confirmationOfClientCompanyDeletion:
			'Are you sure you want to delete this client with its users and configurations?',
		clientCompanyDeletionInProgress: 'Client company deletion in progress',
		clientCompanyWasDeletedSuccessfully: 'Client company was deleted successfully',
		companyNotFound: 'Company not found!',
		loadingCompanyData: 'Loading company data...',
		dataLoadedSuccessfully: 'Data loaded successfully!',
		dataHasBeenSuccessfullyUpdated: 'Data has been successfully updated!',
		userHasBeenSuccessfullyRemovedFromTheCompany:
			'The user has been successfully removed from the company!',
		confirmationOfUserDeletion: 'Are you sure you want to remove this user from the company?',
		invitationLinkHasBeenCopied: 'Link has been copied to clipboard!',
		anErrorHasOccurred: 'An error has occurred',
		loadingDataOfAllCompaniesInProgress: 'Loading data of all companies in progress...',
		uploadDocAreaDragAndDrop: 'Drag & drop files here',
		uploadDocAreaOr: 'or',
		uploadDocAreaBrowseFiles: 'Browse files on your computer',
		uploadDocAreaMaxFileSizeFmt: 'Max file size {}',
		attachmentDeletionInProgress: 'Attachment is being deleted...',
		attachmentWasDeletedSuccessfully: 'Attachment deleted',
	},
	formNotifications: {
		emailRequired: 'Email is required',
		enterValidEmail: 'Please enter a valid email',
		VATNumberRequired: 'VAT Number is required',
		enterValidVATNumber: 'Please enter a valid Swiss VAT Number (CHE-000.000.000)',
		fieldIsRequired: 'is required',
		nameFieldInvalidCharacters: 'Invalid characters',
		nameFieldCharactersLength: 'needs to be at least three characters',
		passwordFieldCharactersLong: 'Password must be 8 characters long.',
		passwordFieldMustContainNumber: 'Invalid password. Must contain one number.',
		passwordNotMatched: 'Password not matched',
	},
	configurationCategory: {
		glassType: 'Glass Type',
		fireResistant: 'Fire Resistant Glass',
		spacer1: 'Spacer',
		gas1: 'Gas',
		middleGlass: 'Middle Glass (Coated)',
		spacer2: 'Spacer',
		gas2: 'Gas',
		outsideGlass: 'Outside Glass (Coated)',
		structure: 'Structure',
		structure_info: '',
		manufacturer: 'Manufacturer',
		manufacturer_info: '',
		fireResistanceClass: 'Fire resistance',
		fireResistanceClass_info: 'EN 13501-2',
		insulation: 'U-Value',
		insulation_info: 'In [W/m²K]\nAccording to EN 673',
		application: 'Application',
		application_info: '',
		whiteGlass: 'Clear glass',
		whiteGlass_info: '',
		resistanceClass: 'Resistance',
		resistanceClass_info: 'According to EN 1627',
		buttJoints: 'Butt Joints',
		buttJoints_info: '',
		sound: 'Sound Reduction Rw',
		sound_info: 'According to EN 140-3',
		thickness: 'Thickness',
		sqmWeight: 'Kg/m²',
		sqmPrice: 'CHF/m²',
	},
	filterName: {
		StructureFilter: 'Structure',
		ManufacturerFilter: 'Manufacturer',
		FireClassFilter: 'Fire resistance',
		InsulationFilter: 'U-Value',
		ApplicationFilter: 'Application',
		WhiteGlassFilter: 'Extra-white',
		ResistanceClassFilter: 'Resistance',
		ButtJointsFilter: 'Butt Joints',
		SoundFilter: 'Sound Reduction',
	},
	commonConfigurationAction: {
		recordPositions: 'Record positions',
		updateGlassType: 'Update Glass Type',
		editThisGlass: 'Edit this glass',
		resetGlass: 'Reset glass',
		resetConfiguration: 'Reset all positions',
		saveAsPdf: 'Save as PDF',
		creatingPdf: 'Creating PDF...',
		glassDotPdfFmt: 'CDR_Glass_{date}.pdf',
		configurationDotPdfFmt: 'CDR_Configuration_{date}.pdf',
		backToPositionsEntry: 'Back to Positions Entry',
		continue: 'Continue',
		continueWithoutReference: 'Continue without Reference',
		open: 'Open',
		reopen: 'Reopen',
		delete: 'Delete',
		complete: 'Complete',
		edit: 'Edit',
		doOrder: 'Order',
		doRequest: 'Request Quote',
		duplicate: 'Duplicate as draft',
		firstSelectProperties: 'Select Properties',
		secondCustomize: 'Customize',
		sizeValidationError:
			'Please make sure to fill in all required fields: width, height, and quantity.',
		selectProductToContinue: 'Select product to continue.',
		priceInfoBoxFmt:
			'Daily price incl. warehouse delivery & energy cost surcharge (ECS)\nexcl. heavy vehicle fee (HVC) & VAT\nMinimum calculation area per piece: {min_pos_sqm} m²\nShaped glasses +{model_glass_factor}%.',
		priceNotAvailableInfoBox: 'The price for this position is currently only available on request',
		loginForPriceInfoBox: 'Please log in to see prices',
		waitingForPriceApproval: 'Price approval is pending',
		blurredPrice: 'xxx.xx',
		priceOnDemand: 'Price only on demand',
		chfPerSqm: 'CHF/m²',
		orderVolume: 'Order volume',
		volumeFromPrice: 'From {} m²',
	},
	configurationTableHeading: {
		length: 'width',
		width: 'height',
		linearMeterAbbrev: 'LM',
		quantity: 'quantity',
		price: 'price',
		form: 'model',
		formNote:
			'For shaped glasses, please check the box. For orders, attach a drawing below. For circular shapes, a note suffices. For inquiries only, the checkbox without a drawing is sufficient.',
		notes: 'notes',
		cantonalInsurance: 'VKF#',
		cantonalInsuranceLink: 'https://www.bsronline.ch/de/registersuche/',
		totalGlassType: 'Total Glass Type',
		totalCart: 'All Positions',
		blocktotal: 'Total',
		lsva: 'Heavy Vehicle Fee (HVC)',
		vat: 'VAT',
		subtotal: 'Subtotal',
		totalPriceChf: 'Total Amount [CHF]',
		pos: 'pos',
		pc: 'pcs',
		kg: 'kg',
		volumeDiscountFmt: 'The bulk discount for orders from {} m² is already included.',
		constructionSiteDeliveryFmt:
			'Delivery to your company is included in the price. Construction site delivery from {}',
	},
	registrationForm: {
		title: 'Registration',
		registerForPrices: 'By registering, you get access to prices and your personal dashboard.',
		registerButton: 'Register',
		alreadyHaveAccount: 'Already have an account? ',
		logIn: 'Log in',
	},
	loginForm: {
		title: 'Login',
		dontHaveAccount: "Don't have an account?",
		loginButton: 'Login',
		lostPassword: 'lost password',
		signUp: 'Sign up',
		successfullyLoggedIn: 'You are successfully logged in!',
		loggingInProgress: 'Logging in progress',
		successfullyLoggedOut: 'You have successfully logged out',
	},
	lostPasswordForm: {
		dontHaveAccount: "Don't have an account?",
		title: 'lost password',
		submitButton: 'reset password',
		signUp: ' sign up',
		loggingInProgress: 'Reset in progress',
		successfullyLoggedIn: 'Reset success',
	},
	resetConfigurationForm: {
		title: 'Reset Configuration',
		text: 'Do you want to start a new configuration and keep the current One? Configuration code is valid for 30 days.',
		configurationCode: 'Configuration code',
		resetButton: 'Reset',
		or: 'or',
		textNew: 'do you want to Start a new configuration and delete all content and files.',
		resetDeleteButton: 'Reset and delete',
		noConfigurationDefinedResetGlass: 'No configuration defined. Only reset the current glass.',
		confirmReset: 'Do you want to start a new configuration and delete all contents and files?',
		backToConfigurator:
			'To go back to the configurator, click on the pencil icon in the glass type title to edit it.',
	},
	resetGlassForm: {
		title: 'Reset Glass',
		text: 'Do you want to reset the current glass and filters?',
		resetButton: 'Reset',
	},
	guestForm: {
		title: 'Guest',
		enterContactDetails: 'Give us your contact details so we can send you an offer by email.',
		additionalInfo: 'Additional Infos',
		continue: 'Continue',
	},
	accountCompanyForm: {
		title: 'Company',
	},
	accountPage: {
		companyFormTitle: 'Company',
		userFormTitle: 'User',
		usersInCompanyTitle: 'users in company',
		registerNewUser: 'Register new user for this company',
		copyInviteLinkFmt: 'Copy link for self-registration with {company} to clipboard',
		saveButton: 'Save',
	},
	configurationCodeForm: {
		title: 'Configuration code',
		enterYourCodePlaceholder: 'enter your code',
		overwriteConfigurationCheckbox: 'this will overwrite your current configuration',
		submitButton: 'load',
	},
	resetPasswordForm: {
		title: 'Lost password',
		submitButton: 'Reset password',
	},
	homePage: {
		allStatementsWithoutGuarantee: 'All statements without guarantee',
		disclaimer: 'Disclaimer',
		disclaimerLinkFmt: '{}/uploads/2024/05/Disclaimer-Configurator-EN.pdf',
		termsAndConditions: 'Terms and Conditions',
		termsAndConditionsLinkFmt: '{}/uploads/2024/05/TERMS-EN.pdf',
		cookieSettings: 'Cookie Settings',
	},
	cartPage: {
		configurationCodeTitle: 'Configuration code',
		configurationCodeLabel: 'code',
		configurationCodeDescription:
			'This is the code for your configuration, if you want to retrieve it later without login. It is valid for 30 days.',
		yourReference: 'Your Reference',
		yourReferenceInputLabel: 'Reference 1',
		yourReferenceInputLabelPlaceholder: '',
		yourReferenceOptionalTitle: '',
		buildingReferenceInputLabel: 'Reference 2',
		buildingReferenceInputLabelPlaceholder: '',
		uploadedDocuments: 'Uploaded documents',
		addNewTypeTitle: 'Add new glass type',
		createFirstConfiguration: 'Create your first configuration',
		addNewTypeBtn: 'add',
		cartIsEmpty: 'No positions added',
		termsText:
			'I accept the <a href="{termsURL}" target="_blank">general terms</a> and the <a href="{disclaimerURL}" target="_blank">liability disclaimer</a>',
	},
	pageNavigation: {
		login: 'Login',
		myCode: 'My Code',
		dashboard: 'Dashboard',
		account: 'Account',
		logout: 'Logout',
		adminDashboard: 'Admin Dashboard',
		configurator: 'Configurator',
	},
	workflowNavigation: {
		configure: 'Configure',
		cart: 'Record Positions',
		requestOrOrder: 'RFQ / Order',
	},
	requestOrOrderPage: {
		doRequest: 'Request Quote',
		doOrder: 'Order',
		preferredQuoteDate: 'RFQ Until',
		preferredOrderDeliveryDate: 'Delivery Date',
	},
	orderConfirmationPage: {
		orderConfirmationTitle: 'Order confirmation',
		quoteConfirmationTitle: 'Quotation Request Confirmation',
		emailConfirmationSentToFmt: 'An email confirmation has been sent to {email}.',
		backToStart: 'Back to the start',
	},
	adminDashboardPage: {
		clientsTitle: 'Clients',
	},
	contactCompanyInformation: {
		showPrices: 'Show Prices',
		customerReference: 'Customer Nr.',
		company: 'company',
		address: 'address',
		zip: 'ZIP',
		city: 'city',
		tel: 'Tel',
		email: 'Email',
		numAccounts: 'Users',
	},
	genericWarningPopup: {
		warning: 'Warning',
		confirm: 'Confirm',
		abort: 'Cancel',
	},
	deletePositionPopup: {
		title: 'Delete position',
		description: 'Are you sure you want to delete this position?',
		deleteButton: 'Delete',
	},
	deleteAttachmentPopup: {
		title: 'Delete attachment',
		description: 'Are you sure you want to delete this attachment?',
		deleteButton: 'Delete',
	},
	supportedDevicesPopup: {
		title: 'Mobile',
		description:
			'This configurator is currently not supported on mobile devices. Please use a desktop computer or resize the browser.',
	},
	glassCharacteristics: {
		glassStructure: 'Structure',
		fireResistance: 'Fire Resistance',
		uValue: 'U-Value',
		thickness: 'Thickness',
		clearGlass: 'Clear glass',
		resistanceClass: 'Resistance Class',
		buttJoints: 'Suitable for butt-joints',
		application: 'Suitable applications',
		sound: 'Noise dampening',
		valid: 'Valid configuration',
		glassMaxSizeWarningFormat: 'Glass is restricted to {max_width_mm} x {max_height_mm} mm',
		filteredCategoryLabel: 'Unavailable due to filter',
	},
	filters: {
		changesUValue: 'Changes U-Value',
		gas_argon: 'Argon',
		gas_krypton: 'Krypton',
		gas_mixedGas: 'Mixed gas',
		gas_expensive: 'The price for this gas is currently very volatile and expensive',
		spacer_format: '{} mm',
		structure_1Glazed: 'Simple (Mono)',
		structure_2Glazed: 'Double ISO',
		structure_3Glazed: 'Triple ISO',
		manufacturer_indep: 'Independent',
		manufacturer_AGC: 'AGC',
		manufacturer_GlasTroesch: 'Glas Trösch',
		manufacturer_Pilkington: 'Pilkington',
		manufacturer_HeroFire: 'Hero-Fire',
		fireResistanceClass_EI30: 'EI30',
		fireResistanceClass_EI60: 'EI60',
		fireResistanceClass_EI90: 'EI90',
		insulation_UValueFormat: '{}',
		application_in: 'Inside',
		application_inOut: 'Inside/Outside',
		application_outOut: 'Outside/Outside',
		whiteGlass_yes: 'Yes',
		whiteGlass_no: 'No',
		resistanceClass_none: 'None',
		resistanceClass_rc2: 'RC2 (P4A)',
		resistanceClass_rc3: 'RC3 (P5A)',
		resistanceClass_rc4: 'RC4 (P6B)',
		buttJoints_yes: 'Yes',
		buttJoints_no: 'No',
		sound_format: '{} dB',
		sound_format_better_than: 'min {} dB',
		sound_format_npd: 'NPD',
	},
	pdfPage: {
		pageFooterFmt: 'Page {pageNum} of {numPages}',
		priceValidUntilFmt: 'Prices valid until {}',
		drafts: 'Drafts',
		order: 'Order',
		orderDeliveryDateFmt: 'Delivery Date {}',
		request: 'Request for Quote',
		requestDueDateFmt: 'RFQ Until {}',
	},
	firebaseErrorMessages: {
		// errors for Cloud Storage
		'storage/unknown': 'An unknown error has occurred.',
		'storage/object-not-found': 'No object exists at the desired reference.',
		'storage/bucket-not-found': 'No bucket is configured for Cloud Storage.',
		'storage/project-not-found': 'No project is configured for Cloud Storage.',
		'storage/quota-exceeded': 'The quota on your Cloud Storage bucket has been exceeded.',
		'storage/unauthenticated': 'User is not authenticated, please authenticate and try again.',
		'storage/unauthorized':
			'User is not authorized to perform the desired action, check your security rules to ensure they are correct.',
		'storage/retry-limit-exceeded':
			'The maximum time limit on an operation (upload, download, delete, etc.) has been exceeded. Try uploading again.',
		'storage/invalid-checksum':
			'The file on the client does not match the checksum of the file received by the server. Try uploading again.',
		'storage/canceled': 'The user has canceled the operation.',
		'storage/invalid-event-name':
			'Invalid event name provided. Must be one of [`running`, `progress`, `pause`]',
		'storage/invalid-url':
			'Invalid URL provided to refFromURL(). Must be in the form: gs://bucket/object or https://firebasestorage.googleapis.com/v0/b/bucket/o/object?token=<TOKEN>',
		'storage/invalid-argument':
			'The argument passed to put() must be a `File`, `Blob`, or `UInt8` array. The argument passed to putString() must be a raw, `Base64`, or `Base64URL` string.',
		'storage/no-default-bucket':
			"No bucket has been set in your configuration's storageBucket property.",
		'storage/cannot-slice-blob':
			'Occurs often when the local file has changed (deleted, saved again, etc.). Try uploading again after verifying the file has not changed.',
		'storage/server-file-wrong-size':
			'The file on the client does not match the size of the file received by the server. Try uploading again.',

		// authentication API Errors
		'auth/claims-too-large':
			'The claims payload provided to setCustomUserClaims() exceeds the maximum allowed size of 1000 bytes.',
		'auth/expired-action-code': 'The link has already expired. Reset the password again.',
		'auth/invalid-action-code': 'The link is invalid. Try again or reset the password again.',
		'auth/email-already-in-use':
			'The provided email is already in use by an existing user. Each user must have a unique email address.',
		'auth/id-token-expired': 'The provided Firebase ID token has expired.',
		'auth/id-token-revoked': 'The Firebase ID token has been revoked.',
		'auth/insufficient-permission':
			'The certificate used to initialize the Admin SDK does not have the necessary permissions to access the requested authentication resource. See Configuring a Firebase Project for documentation on generating a certificate with the appropriate permissions and using it to authenticate the Admin SDKs.',
		'auth/internal-error':
			"The authentication server encountered an unexpected error while trying to process the request. The error message should contain the authentication server's response containing additional information. If the error persists, please report the issue to our Bug Report support channel.",
		'auth/invalid-argument':
			'An invalid argument was provided to an authentication method. The error message should contain additional information.',
		'auth/invalid-claims':
			'The custom claims attributes provided to setCustomUserClaims() are invalid.',
		'auth/invalid-continue-uri': 'The continuation URL must be a valid URL string.',
		'auth/invalid-creation-time': 'The creation time must be a valid UTC date string.',
		'auth/invalid-credential':
			'The certificate used to authenticate the Admin SDKs cannot be used to perform the desired action. Some authentication methods such as createCustomToken() and verifyIdToken() require the SDK to be initialized with a certificate as a refresh token or a default application token. See the documentation on initializing the SDK for how to authenticate the Admin SDKs with a certificate.',
		'auth/invalid-disabled-field':
			'The provided value for the user disabled property is invalid. It must be a boolean.',
		'auth/invalid-display-name':
			'The provided value for the user displayName property is invalid. It must be a non-empty string.',
		'auth/invalid-dynamic-link-domain':
			'The provided dynamic link domain is not configured or authorized for the current project.',
		'auth/invalid-email':
			'The provided value for the user email property is invalid. It must be an email address.',
		'auth/invalid-email-verified':
			'The provided value for the user emailVerified property is invalid. It must be a boolean.',
		'auth/invalid-hash-algorithm':
			'The hashing algorithm must match one of the strings from the list of supported algorithms.',
		'auth/invalid-hash-block-size': 'The hash block size must be a valid number.',
		'auth/invalid-hash-derived-key-length': 'The hash derived key length must be a valid number.',
		'auth/invalid-hash-key': 'The hash key must be a valid byte buffer.',
		'auth/invalid-hash-memory-cost': 'The hash memory cost must be a valid number.',
		'auth/invalid-hash-parallelization': 'The hash parallelization must be a valid number.',
		'auth/invalid-hash-rounds': 'The number of hash rounds must be a valid number.',
		'auth/invalid-hash-salt-separator':
			"The hash algorithm's salt separator field must be a valid byte buffer.",
		'auth/invalid-id-token': 'The provided ID token is not a valid Firebase ID token.',
		'auth/invalid-last-sign-in-time': 'The last sign-in time must be a valid UTC date string.',
		'auth/invalid-page-token':
			'The next page token provided in listUsers() is invalid. It must be a valid non-empty string.',
		'auth/invalid-password':
			'The provided value for the user password property is invalid. It must be a string of at least six characters.',
		'auth/invalid-password-hash': 'The password hash must be a valid byte buffer.',
		'auth/invalid-password-salt': 'The password salt must be a valid byte buffer.',
		'auth/invalid-phone-number':
			'The provided value for the phone number is invalid. It must be a string conforming to the E.164 standard.',
		'auth/invalid-photo-url':
			'The provided value for the user photoURL property is invalid. It must be a URL string.',
		'auth/invalid-provider-data': 'providerData must be a valid array of UserInfo objects.',
		'auth/invalid-provider-id':
			'providerId must be a valid string of a supported provider identifier.',
		'auth/invalid-oauth-responsetype': 'Only one OAuth response type should be set to true.',
		'auth/invalid-session-cookie-duration':
			'The session cookie duration must be a valid number in milliseconds between 5 minutes and 2 weeks.',
		'auth/invalid-uid': 'The provided UID must be a non-empty string of at most 128 characters.',
		'auth/invalid-user-import': 'The user record to be imported is invalid.',
		'auth/maximum-user-count-exceeded':
			'The maximum allowed number of users to import has been exceeded.',
		'auth/missing-android-pkg-name':
			'An Android package name must be provided if the Android app is to be installed.',
		'auth/missing-continue-uri': 'A valid continuation URL must be provided in the request.',
		'auth/missing-hash-algorithm':
			'Importing users with password hashes requires providing the hashing algorithm and its parameters.',
		'auth/missing-ios-bundle-id': 'The request is missing a bundle ID.',
		'auth/missing-uid': 'A UID is required for the current operation.',
		'auth/missing-oauth-client-secret':
			'The OAuth configuration client secret is required to enable the OIDC code flow.',
		'auth/network-request-failed': 'No network connection',
		'auth/operation-not-allowed':
			'The provided login provider is disabled for your Firebase project. Enable it from the Login Method section in the Firebase console.',
		'auth/phone-number-already-exists':
			'The provided phone number is already in use by an existing user. Each user must have a unique phone number.',
		'auth/project-not-found':
			'No Firebase project was found for the certificate used to initialize the Admin SDKs. See Configuring a Firebase Project for documentation on generating a certificate for your project and using it to authenticate the Admin SDKs.',
		'auth/reserved-claims':
			'One or more custom user claims provided to setCustomUserClaims() are reserved. For example, OIDC-specific claims such as (sub, iat, iss, exp, aud, auth_time, etc.) should not be used as keys for custom claims.',
		'auth/session-cookie-expired': 'The provided Firebase session cookie has expired.',
		'auth/session-cookie-revoked': 'The Firebase session cookie has been revoked.',
		'auth/too-many-requests': 'The number of requests exceeds the maximum allowed.',
		'auth/uid-already-exists':
			'The provided UID is already in use by an existing user. Each user must have a unique UID.',
		'auth/unauthorized-continue-uri':
			'The domain of the continuation URL is not whitelisted. Add the domain to the Firebase console.',
		'auth/user-not-found': 'There is no user record corresponding to the provided identifier.',
		'auth/wrong-password': 'Wrong password',

		// other errors
		ok: 'Operation successful',
		cancelled: 'Operation cancelled',
		unknown: 'Unknown error',
		'invalid-argument': 'Invalid argument',
		'deadline-exceeded': 'Deadline exceeded',
		'not-found': 'Not found',
		'already-exists': 'Already exists',
		'permission-denied': 'Permission denied',
		unauthenticated: 'Unauthenticated user',
		'resource-exhausted': 'Resource exhausted',
		'failed-precondition': 'Failed precondition',
		aborted: 'Operation cancelled',
		'out-of-range': 'Out of range',
		unimplemented: 'Unimplemented',
		internal: 'Internal error',
		unavailable: 'Unavailable',
		'data-loss': 'Data loss',
	},
	email: {
		draft: 'Draft',
		request: 'Request for Quote',
		order: 'Order',
		salutationFmt_male: 'Dear {firstName}',
		salutationFmt_female: 'Dear {firstName}',
		salutationFmt_div: 'Dear {firstName}',
		bestRegards: 'Best Regards,',
		yourCDRTeam: 'Your CDR Team',
		confirmationSubject_request: 'Your CDR Request for Quote',
		confirmationSubject_order: 'Your CDR Order',
		confirmationBodyNotesFmt: '<p>Notes:<br><div style="white-space: pre-wrap;">{notes}</div></p>',
		confirmationBodyFmt_request:
			'<div style="font-family: Arial, sans-serif;"><p>{salutation},</p><p>Thank you for your request. We will attend to it immediately.</p>{notes}<p>You will find attached a copy of the request and the submitted documents.</p></div>{signature}',
		confirmationBodyFmt_order:
			'<div style="font-family: Arial, sans-serif;"><p>{salutation},</p><p>Thank you for your order. We will attend to it immediately.</p></div>{signature}',
		showPricesSubject: 'CDR Configurator Prices Enabled',
		showPricesFmt:
			'<div style="font-family: Arial, sans-serif;"><p>{salutation},</p><p>All {company} accounts are now enabled to see prices on the <a href="{configuratorURL}">CDR Configurator</a></p></div>{signature}',
		welcomeNewUserSubject: 'Welcome to the CDR Configurator',
		welcomeNewUserFmt:
			'<div style="font-family: Arial, sans-serif;"><p>{salutation},</p><p>Welcome to the CDR Configurator. Your new account {email} has been created.</p>{checkingPrices}</div>{signature}',
		checkingPricesTitle: 'Verifying price approval',
		checkingPricesFmt: 'The price approval for {company} is granted after a review.',
		pricesAvailableFmt:
			'Price approval for {company} has already been granted. You can now see all available prices.',
	},
	faqPage: {
		typeYourQuestion: 'Type your question',
		back: 'Back',
		foundSingleAnswer: 'Found one answer',
		foundMultipleAnswersFmt: 'Found {numAnswers} answers',
	},
	datasheet: {
		datasheetForGlassFmt: 'Datenblatt for {}',
		datasheetFmt: 'Datasheet {}',
	},
	adminSiteInfo: {
		heading: 'WordPress Configuration Data',
		// Validation error messages
		fieldEmptyOrWhitespaceFmt: '{field} is empty or contains only whitespace',
		fieldValueFmt: '{field}: {value}',
		fieldNotANumberFmt: '{field} ({num}) is not a number',
		fieldLessThanMinFmt: '{field} ({num}) < {min}',
		fieldGreaterThanMaxFmt: '{field} ({num}) > {max}',
		fieldNumValueFmt: '{field}: {n}',
		fieldEmptyFmt: '{field} is empty',
		fieldOnlyRowsLongFmt: '{field} is only {lines} (< {min_rows}) rows long',
		rowOnlyEntriesLongFmt: 'Row {row} is only {cols} (< {min_cols}) entries long',
		rowTooManyEntriesFmt: 'Row {row} has too many entries {cols} (> {max_cols})',
		fieldErrorsFmt: '{field} {errors}',
		fieldHasRowsFmt: '{field} has {lines} rows',
		fieldNotAListFmt: '{field} is not a list',
		fieldOnlyEntriesFmt: '{field} has only {length} (< {min}) entries',
		fieldTooManyEntriesFmt: '{field} has too many entries ({length} > {max})',
		fieldHasEntriesFmt: '{field} has {length} entries',
		fieldNotAnObjectFmt: '{field} is not an object',
		fieldNotOfTypeFmt: '{field} is not of type "{type}"',
		fieldDataValueFmt: '{field}: {data}',
		jsonFormatErrorFmt: 'Error in {field} JSON format: {message}',
		glassDbNotLoaded: 'Glass database not loaded',
		glassLoadedFmt: '{glassLabel}: {len} glasses loaded.',
		uValueDbOnlyEntriesFmt: 'U-values DB {struct} has only {len} (< {min}) entries',
		uValueDbHasEntriesFmt: 'U-values DB {struct} has {len} entries',
		glassPricesMissingCategoryFmt: 'Glass prices missing category "{category}"',
		glassPricesMissingGlazingFmt: 'Glass prices category {category} missing {glazing}',
		glassPricesTooFewEntriesFmt: 'Glass prices category {category} {glazing} has only {count} (< {min}) entries',
		glassPricesLoadedFmt: '{categories} price categories, {totalPrices} prices loaded',
		// Field names
		pricingDataMissing: 'Pricing data missing',
		minSquareMeters: 'Minimum square meters',
		modelGlassFactor: 'Shaped glass factor',
		vatRate: 'VAT rate',
		lsvaPerM2: 'Heavy vehicle fee/m2',
		minLsva: 'Minimum heavy vehicle fee',
		volumeDiscountFromM2: 'Volume discount from x m2',
		volumeDiscountInfoMissing: 'Volume discount info missing',
		maxGlassWidth: 'Maximum glass width [mm]',
		maxGlassHeight: 'Maximum glass height [mm]',
		glassTranslationJson: 'Glass translations JSON',
		fireResistantGlassCsv: 'Fire resistant glass CSV',
		middleGlassCsv: 'Middle glass CSV',
		outsideGlassCsv: 'Outside glass CSV',
		pricesCsv: 'Prices CSV',
		uValuesJson: 'U-values JSON',
		verasIdsJson: 'VERAS IDs JSON',
		noFireResistantDatasheets: 'No fire resistant glass datasheets',
		soundDampeningDb: 'Sound dampening DB',
		genericFrgIds: 'Generic FRG IDs of sound dampening DB',
		emailSignature: 'Email signature',
		emailSignaturePresent: 'Email signature is present',
		emailRequest: 'Email request',
		emailOrder: 'Email order',
		senderEmail: 'Sender email',
		newUserEmail: 'New user email',
		newUserEmailCc: 'New user email (CC)',
	},
};
